import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useTheme, useMediaQuery } from '@mui/material';

const AlphabetFilter = ({ selectedLetter, setSelectedLetter, availableLetters  }) => {
    const alphabet = ['Todos', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];

    const [selected, setSelected] = useState('Todos');

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    if(isMobile) return null;
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: isTablet ? 'wrap' : 'nowrap',
                overflowX: 'auto',
                borderBottom: '1px solid #ccc',
                maxWidth: 1140, 
                width: { sm: '90%', lg: '90%'},
                mx: 'auto',
                pb: 1,
                mt: 3
            }}
        >
        {alphabet.map((letter) => {
            const disabled = letter !== 'Todos' && !(availableLetters || []).includes(letter);
            const isSelected = selectedLetter === letter;

            return (
            <Button
                key={letter}
                onClick={() => !disabled && setSelectedLetter(letter)}
                disabled={disabled}
                sx={{
                minWidth: '36px',
                mx: 0.2,
                color: disabled ? '#ccc' : isSelected ? '#0078d7' : '#000',
                backgroundColor: isSelected ? '#e0f0ff' : 'transparent',
                textTransform: 'none',
                fontWeight: isSelected ? 'bold' : 'normal',
                fontSize: '0.8rem',
                borderRadius: 0,
                padding: '6px 8px',
                '&:hover': {
                    backgroundColor: disabled ? 'transparent' : '#d0e7ff',
                },
                }}
            >
                {letter}
            </Button>
            );
        })}
        </Box>
    );
};

export default AlphabetFilter;
